module.exports = __webpack_public_path__ + "img/acd6a37e85180ebe047ce9b7f7f7c7a6.png";